import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.75 11.408v5.387c0 1.575-.182 2.862-1.023 3.693-.837.829-2.131 1.008-3.723 1.008H5.997c-1.591.004-2.885-.172-3.724-1-.841-.83-1.023-2.117-1.023-3.692V9.406c0-1.576.182-2.863 1.023-3.694.837-.828 2.131-1.007 3.723-1.007h7.334c-.403.435-.73.942-.958 1.5H5.996c-1.604 0-2.307.216-2.669.574-.354.35-.572 1.027-.577 2.571h9.408c.139.541.366 1.046.665 1.5H2.75v5.954c0 1.583.219 2.272.577 2.625.36.356 1.063.571 2.667.567h10.01c1.604 0 2.307-.217 2.669-.575.358-.354.577-1.043.577-2.626v-4.228a5 5 0 0 0 1.5-1.16",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M5.6 17.155h1.8M9.65 17.155h3.6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22 8.1a5 5 0 1 1-10 0 5 5 0 0 1 10 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m18.855 9.69-2.038-1.215v-2.62"
    }, null, -1)
  ]))]))
}
export default { render: render }